module.exports = __webpack_public_path__ + "static/img/020_TO8_1484.891b392.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/020_TO8_1484.jpg
// module id = k092
// module chunks = 0